// src/store/slices/notesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

interface NotesState {
    notes: Record<string, string>;
    loading: boolean;
    error: string | null;
}

const initialState: NotesState = {
    notes: {},
    loading: false,
    error: null,
};

const generateKey = (courseId: number, lessonId: number) => `${courseId}_${lessonId}`;

const notesSlice = createSlice({
    name: 'notes',
    initialState,
    reducers: {
        fetchNotesStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchNotesSuccess(state, action: PayloadAction<{ courseId: number; lessonId: number; notes: string }>) {
            const { courseId, lessonId, notes } = action.payload;
            const key = generateKey(courseId, lessonId);
            state.notes[key] = notes;
            state.loading = false;
        },
        fetchNotesFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        saveNotesStart(state) {
            state.loading = true;
            state.error = null;
        },
        saveNotesSuccess(state, action: PayloadAction<{ courseId: number; lessonId: number; notes: string }>) {
            const { courseId, lessonId, notes } = action.payload;
            const key = generateKey(courseId, lessonId);
            state.notes[key] = notes;
            state.loading = false;
        },
        saveNotesFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchNotesStart,
    fetchNotesSuccess,
    fetchNotesFailure,
    saveNotesStart,
    saveNotesSuccess,
    saveNotesFailure,
} = notesSlice.actions;

export default notesSlice.reducer;

export const selectNotes = (state: RootState, courseId: number, lessonId: number) =>
    state.notes.notes[`${courseId}_${lessonId}`];